import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Container,
  TableHead,
  TableBody,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  Button,
  Checkbox,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { Search as SearchIcon } from "react-feather";
import {
  categoriesServices,
  doctorServices,
  laboratoryServices,
} from "../services";
import { AuthContext } from "../context";
import {
  TextField,
  ModalBase,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "./";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function EditCategory(props) {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const { register, handleSubmit, setValue, errors } = useForm();
  const [doctors, setDoctors] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [labId, setLabId] = useState("0");
  const [childLaboratories, setChildLaboratories] = useState([]);
  const [laboratoryId] = useState(authState.user.laboratory._id);
  const [filter, setFilter] = useState("");
  const [selectedDoctorsIds, setSelectedDoctorsIds] = useState(
    props.category.doctors.map((doctor) => doctor._id)
  );

  const {
    user: {
      role: { name: roleName },
    },
  } = authState;
  const isAdmin = roleName === "LABORATORY_ADMIN";
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    async function getDoctors() {
      // try {
      //   const { status, response } = await doctorServices.getDoctors({
      //     page,
      //     limit,
      //     token: authState.token,
      //   });
      //   if (status === 200) {
      //     setDoctors(response.doctors);
      //     setLimit(response.limit);
      //     setCount(response.total);
      //     setPage(response.page);
      //   }
      // } catch (e) {
      //   console.log(e);
      // }
      try {
        const { status, response } = await doctorServices.getDoctorsFilter({
          text: filter,
          page,
          limit,
          token: authState.token,
        });
        if (status === 200) {
          setDoctors(response.doctors);
          setLimit(response.limit);
          setCount(response.total);
          setPage(response.page);
        }
      } catch (e) {
        console.log(e);
      }
    }
    getDoctors();
  }, [page, limit, authState, refresh]);

  useEffect(() => {
    async function getChildLaboratories() {
      try {
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            laboratoryId: authState.user.laboratory._id,
            text: "",
            page,
            limit,
            token: authState.token,
          });
        if (status === 200) {
          setChildLaboratories(response.laboratories);
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (authState.user.role.name === "LABORATORY_ADMIN") {
      getChildLaboratories();
    }
  }, [page, limit, authState]);

  useEffect(() => {
    setTimeout(() => {
      setValue("name", props.category.name);
      setValue("description", props.category.description);
      setLabId(props.category.laboratory._id);
    });
  }, [props, setValue]);

  const handleSelectAll = (event) => {
    let newSelectedDoctorsIds;
    if (event.target.checked) {
      newSelectedDoctorsIds = doctors.map((doctor) => doctor._id);
    } else {
      newSelectedDoctorsIds = [];
    }
    setSelectedDoctorsIds(newSelectedDoctorsIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedDoctorsIds.indexOf(id);
    let newSelectedDoctorsIds = [];

    if (selectedIndex === -1) {
      newSelectedDoctorsIds = newSelectedDoctorsIds.concat(
        selectedDoctorsIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedDoctorsIds = newSelectedDoctorsIds.concat(
        selectedDoctorsIds.slice(1)
      );
    } else if (selectedIndex === selectedDoctorsIds.length - 1) {
      newSelectedDoctorsIds = newSelectedDoctorsIds.concat(
        selectedDoctorsIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedDoctorsIds = newSelectedDoctorsIds.concat(
        selectedDoctorsIds.slice(0, selectedIndex),
        selectedDoctorsIds.slice(selectedIndex + 1)
      );
    }

    setSelectedDoctorsIds(newSelectedDoctorsIds);
  };

  const getDoctorsFilter = async (text) => {
    // try {
    //   const { status, response } = await doctorServices.getDoctorsFilter({
    //     text,
    //     page,
    //     limit,
    //     token: authState.token,
    //   });
    //   if (status === 200) {
    //     setDoctors(response.doctors);
    //     setLimit(response.limit);
    //     setCount(response.total);
    //     setPage(response.page);
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
    setPage(1);
    setRefresh((prev) => !prev);
  };

  const editCategory = async (category) => {
    let doctorsIds = [];
    selectedDoctorsIds.forEach((id) => {
      doctorsIds.push({
        _id: id,
      });
    });

    let payload = {
      name: category.name,
      description: category.description,
      laboratoryId: laboratoryId,
      doctors: doctorsIds,
    };
    try {
      const { status, response } = await categoriesServices.updateCategory({
        _id: props.category._id,
        payload,
        token: authState.token,
      });
      switch (status) {
        case 200:
          props.toast("Unidad de negocio actualizado con exito", true);
          props.reload();
          props.close();
          break;
        default:
          break;
      }
      if (response.error) {
        props.toast(response.error.message, true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onKeyPress = (key) => {
    if (key.charCode === 13) getDoctorsFilter(filter);
  };

  return (
    <ModalBase
      categoryModal
      open={props.open}
      close={props.close}
      title="Editar Categoria"
    >
      <Container maxWidth={false}>
        <form className={classes.form} onSubmit={handleSubmit(editCategory)}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="name"
                label="Nombre"
                name="name"
                autoComplete="name"
                size="small"
                inputRef={register({
                  required: "Nombre requerido",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.name ? true : false}
                helperText={errors.name ? errors.name.message : ""}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                rows={4}
                id="description"
                label="Descripción"
                name="description"
                autoComplete="description"
                size="small"
                inputRef={register({
                  required: "Descripción requerida",
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors.description ? true : false}
                helperText={
                  errors.description ? errors.description.message : ""
                }
              />
            </Grid>
            {isAdmin && (
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  className={`${classes.formControl}  ${classes.shrinkLabel}`}
                >
                  <Select
                    value={labId}
                    onChange={(e) => setLabId(e.target.value)}
                    MenuProps={MenuProps}
                    className={classes.select}
                    input={<TextField />}
                  >
                    <MenuItem disabled="true" value="0">
                      Unidad de negocio *
                    </MenuItem>
                    {childLaboratories.map((element, index) => (
                      <MenuItem key={index} value={element._id}>
                        {element.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} sm={3} container direction="row">
              <Button
                type="submit"
                fullWidth
                size="small"
                variant="contained"
                color="secondary"
                className={classes.button}
              >
                Guardar
              </Button>
            </Grid>
            <Grid item xs={12} sm={3} container direction="row">
              <Button
                fullWidth
                size="small"
                variant="contained"
                color="primary"
                onClick={() => props.close()}
                className={`${classes.button} ${classes.cancel}`}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </form>
        <Grid item xs={12} sm={12} style={{ padding: "16px 0 8px 0" }}>
          <TextField
            type={"text"}
            name={"filter"}
            value={filter}
            fullWidth
            placeholder={"¿Que estas buscando?"}
            fontWeight="bold"
            className={classes.input}
            onKeyPress={onKeyPress}
            style={{ justifyContent: "flex-end" }}
            iconComponent={() => <SearchIcon onClick={() => {}} />}
            onClickIcon={() => getDoctorsFilter(filter)}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Grid>
      </Container>
      <Grid item xs={12} sm={12}>
        <div className={classes.root}>
          <Container maxWidth={false}>
            <BaseTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>
                    <Checkbox
                      checked={selectedDoctorsIds.length === doctors.length}
                      color="secondary"
                      indeterminate={
                        selectedDoctorsIds.length > 0 &&
                        selectedDoctorsIds.length < doctors.length
                      }
                      onChange={handleSelectAll}
                    />
                  </StyledTableCell>
                  <StyledTableCell>Rut</StyledTableCell>
                  <StyledTableCell>Nombre</StyledTableCell>
                  <StyledTableCell>Apellido</StyledTableCell>
                  <StyledTableCell>Sexo</StyledTableCell>
                  <StyledTableCell>Fecha de nacimiento</StyledTableCell>
                  <StyledTableCell>Teléfono</StyledTableCell>
                  <StyledTableCell>Teléfono de actividad</StyledTableCell>
                  <StyledTableCell>Correo</StyledTableCell>
                  <StyledTableCell>Especialidad 1</StyledTableCell>
                  <StyledTableCell>Especialidad 2</StyledTableCell>
                  <StyledTableCell>Especialidad 3</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {doctors.map((doctor) => (
                  <StyledTableRow key={doctor._id}>
                    <StyledTableCell>
                      <Checkbox
                        checked={selectedDoctorsIds.indexOf(doctor._id) !== -1}
                        onChange={(event) => handleSelectOne(event, doctor._id)}
                        value="true"
                      />
                    </StyledTableCell>
                    <StyledTableCell>{doctor.rut}</StyledTableCell>
                    <StyledTableCell>{doctor.name}</StyledTableCell>
                    <StyledTableCell>{doctor.lastName}</StyledTableCell>
                    <StyledTableCell>{doctor.gender}</StyledTableCell>
                    <StyledTableCell>
                      {doctor.birthdate !== "Invalid date"
                        ? doctor.birthdate
                        : "N/A"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.phone ? doctor.phone : "N/A"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.activityPhone ? doctor.activityPhone : "N/A"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.email ? doctor.email : "N/A"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.specialties[0].name}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.specialties[1]
                        ? doctor.specialties[1].name
                        : "N/A"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {doctor.specialties[2]
                        ? doctor.specialties[2].name
                        : "N/A"}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </BaseTable>
            <TablePagination
              labelRowsPerPage="Registros por página"
              component="div"
              count={count}
              onChangeRowsPerPage={(e) => setLimit(e.target.value)}
              onChangePage={(e, page) => setPage(page + 1)}
              page={page - 1}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 25, 50, 100]}
            />
          </Container>
        </div>
      </Grid>
    </ModalBase>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  button: {
    height: 45,
    borderRadius: 25,
    boxShadow: "unset",
    textTransform: "uppercase",
    fontWeight: "bold",
    "&:hover": {
      boxShadow: "unset",
    },
  },
  cancel: {
    backgroundColor: "transparent",
    color: theme.palette.secondary.main,
    border: "3pt solid" + theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },
  dialogTitle: {
    textAlign: "Center",
  },
  formControl: {
    width: "100%",
    minWidth: 120,
  },
}));
